// components/CustomDropDown.tsx
import React from "react";
import { Select, MenuItem } from "@mui/material";

interface OptionMap {
  option: {
    id: string | number;
    name: string;
  };
}

interface CustomDropDownProps {
  value: string;
  question: {
    id: number;
    label: string;
    questionOptionMaps: OptionMap[];
  };
  handleFieldChange: (id: string | number, value: string) => void;
  inputClasses?: string;
  onBlur?: () => void;
}

const CustomDropDown: React.FC<CustomDropDownProps> = ({
  value,
  question,
  handleFieldChange,
  inputClasses = "",
  onBlur
}) => {
  console.log("CustomDropDown rendered with value:", value, "and question:", question);
  return (
    <Select
      onBlur={onBlur}
      className={inputClasses}
      id={`select-${question.id}`}
      value={value}
      // Generated by Copilot
      onChange={(e) =>
        handleFieldChange(String(question.id), e.target.value as string)
      }
      displayEmpty
      renderValue={(selected) =>
        !selected ? (
          <span style={{ color: "var(--gray-700)" }}>
            Select
          </span>
        ) : (
          selected
        )
      }
      sx={{
        width: "100%",
        height: 48,
        padding: "0 0.75rem",
        border: "0.5px solid var(--gray-10)",
        borderRadius: "var(--border-radius-md)",
        fontSize: "16px",
        color: "var(--gray-700)",
        // transition: "var(--transition)",
        backgroundColor: "White",
        "&:hover": {
          backgroundColor: "transparent !important",
        },
        "&:focus": {
          outline: "none",
          borderColor: "var(--primary-blue)",
          boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.1)",
        },
        ".MuiSelect-select": {
          paddingTop: 6,
          paddingBottom: 6,
          lineHeight: 1.2,
          display: "flex",
          alignItems: "center",
          paddingLeft: "0px",
          color: "#051B46",
          fontSize: "16px",
        },
        ".MuiOutlinedInput-notchedOutline": {
          borderColor: "var(--gray-300)",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "var(--gray-300)",
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 200,
            borderRadius: "var(--border-radius-md)",
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "var(--gray-300)",
            },
            "& .Mui-selected": {
              backgroundColor: "var(--gray-300)",
            },
          },
        },
      }}
    >
      <MenuItem value="" disabled sx={{ fontSize: "16px", color: "#051B46" }}>
        <p>Select</p>
      </MenuItem>
      {question.questionOptionMaps.map((optionMap) => (
        <MenuItem key={optionMap.option.id} value={optionMap.option.name} sx={{ fontSize: "16px", color: "#051B46" }}>
          {optionMap.option.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomDropDown;